module.exports = __webpack_public_path__ + "img/p-4.b63e9746.png";